import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { PhoneCall } from "lucide-react";
import { DEMO_LINK } from "@/App";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-ink/70 border-b border-line" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="font-heading text-lg md:text-xl font-bold tracking-tight" data-testid="logo-link">
          OrderHalal<span className="text-terra">.ai</span>
        </a>
        <a
          href={DEMO_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-demo-button"
          className="group inline-flex items-center gap-2 rounded-full bg-terra px-5 py-2.5 text-sm font-semibold text-cream hover:bg-terra-hover transition-[background-color,transform] duration-300 hover:-translate-y-0.5"
        >
          <PhoneCall className="w-4 h-4" strokeWidth={1.5} />
          Book a Free Demo
        </a>
      </div>
    </motion.header>
  );
};

export default Header;
